// useFixtureKey — the id a widget fetches its data by (BenBet W1).
//
// app-api keys fixtures by the StatsBomb match id ("3999639"), not a slug of the
// label: a pairing like "Arsenal v Everton" exists in several seasons, so a slug
// is ambiguous. Widgets still receive the human label (the legacy layer splits it
// for team names), so this hook maps label → match id via the store, which
// <FixturesSync> fills from GET /fixtures.
//
// Returns null until the fixture list has loaded (or for a label not in it);
// useWidgetData stays disabled on a null id, so the widget shows its skeleton
// rather than fetching the wrong match.

import { useBentoStore } from "../store/index.js";

export function useFixtureKey(label: string | null | undefined): string | null {
  return useBentoStore((s) => (label ? s.fixtureIds[label] ?? null : null));
}
